module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-7d0cec5404856c3f65b58d34a490f058.png";